import { object, string } from 'yup';

export const validationSchema = object().shape({
  email: string()
    .email('Please enter a valid email address')
    .required('Email address is required'),
});
